<wl-focus-reset-on-navigation *wlClientOnly />
<ng-progress *wlClientOnly ngProgressRouter aria-live="polite" />
<wl-load-fonts font="Lato" />
<wl-load-fonts font="Baton" />
<wl-environment-classes />
<wl-visitor-identification />
<wl-scroll-manager />
<wl-header-open-essent-container />
<main id="main-content" tabindex="-1">
  <router-outlet />
</main>
<wl-chatbot-iadvize [login]="false" />
<wl-conversational-chat-ui [login]="false" />
<wl-load-account *wlClientOnly />
<wl-cookiewall-container />
